import { Badge } from "@radix-ui/themes";

export function getQuackAnsweredText(value: boolean): string {
  return value ? "Answered" : "Not Answered";
}

export function QuackAnsweredFormatter({
  value,
  size = "1",
}: {
  value: boolean;
  size?: "1" | "2";
}) {
  return (
    <Badge
      variant={value ? "solid" : "soft"}
      color={value ? "green" : "gray"}
      size={size}
    >
      {getQuackAnsweredText(value)}
    </Badge>
  );
}
